<template>
  <div>
    <slot v-if="verifyScope()" />
    <slot name='not' v-if="!verifyScope()" />
  </div>
</template>

<script>
export default {
  name: "ScopeProvider",
  props: ["scope"],
  methods: {
    verifyScope() {
      return this.$store.getters["auth/getScope"](this.scope);
    },
  },
};
</script>